import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import styled from 'styled-components';
import { prefix } from '../../tools/settings';
import media from '../../tools/media';
import Icon from '../Icon';
import Link from '../Link';
import Button from '../Button';
import CloseButton from '../CloseButton';
var Alert = styled.div.withConfig({
  displayName: "Alertstyles__Alert",
  componentId: "sc-1rvnx1u-0"
})(["display:flex;position:relative;margin-bottom:24px;min-height:48px;padding-left:20px;padding-right:20px;background:var(--dentsu-color-b50);border-left:2px solid var(--dentsu-color-b600);.", "-alert__dismiss{&:hover{background:var(--dentsu-color-white);}}&&{.", "-frame__content > &{border-left:none;border-bottom:1px solid var(--dentsu-color-b150);margin-bottom:0;min-height:60px;.", "-alert__action--small{display:none;}.", "-alert__action--large{display:block;}.", "-alert__text{margin-top:20px;margin-bottom:20px;}.", "-alert__icon{margin-top:18px;}}}.", "-alert__action--large{display:none;}.", "-alert__action-button__inline{display:none;}&.", "-alert--isToast{border:none;padding-left:12px;padding-right:12px;background:var(--dentsu-color-b150);&.", "-alert--success{background:var(--dentsu-color-g200);}&.", "-alert--warning{background:var(--dentsu-color-a200);}&.", "-alert--error{background:var(--dentsu-color-r200);}&.", "-alert--task{background:var(--dentsu-color-b150);}&.", "-alert--notification{background:var(--dentsu-color-b150);}.", "-alert__action{display:none;}.", "-alert__dismiss{right:12px;top:12px;transform:none;}}&.", "-alert--isBroadcast{padding-left:62px;border-left:none;border-bottom:2px solid var(--dentsu-color-b150);margin-bottom:0;.", "-alert__dismiss{right:6px;top:6px;transform:none;}.", "-alert__layout{max-width:1316px;}.", "-alert__text{display:block;}&.", "-alert--success{border-color:var(--dentsu-color-g200);}.", "-alert__broadcast-link__narrow{margin-top:8px;display:inline-block;", "}.", "-alert__broadcast-link__wide{display:none;", "}}&.", "-alert--isMultiline{.", "-alert__text{display:block;}}&.", "-alert--warning{border-color:var(--dentsu-color-a500);background:var(--dentsu-color-a100);}&.", "-alert--success{border-color:var(--dentsu-color-g600);background:var(--dentsu-color-g100);}&.", "-alert--error{border-color:var(--dentsu-color-r500);background:var(--dentsu-color-r100);}&.", "-alert--task{border-color:var(--dentsu-color-b600);background:var(--dentsu-color-b50);}&.", "-alert--notification{border-color:var(--dentsu-color-b600);background:var(--dentsu-color-b50);}&.", "-alert--isDismissable{padding-right:60px;}"], prefix, prefix, prefix, prefix, prefix, prefix, prefix, prefix, prefix, prefix, prefix, prefix, prefix, prefix, prefix, prefix, prefix, prefix, prefix, prefix, prefix, prefix, media.xlarge(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        display: none;\n      "]))), prefix, media.xlarge(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        display: inline-block;\n      "]))), prefix, prefix, prefix, prefix, prefix, prefix, prefix, prefix);
var AlertLayout = styled.div.withConfig({
  displayName: "Alertstyles__AlertLayout",
  componentId: "sc-1rvnx1u-1"
})(["display:flex;flex-grow:1;margin:0 auto;position:relative;align-items:center;"]);
var AlertLayoutIcon = styled.div.withConfig({
  displayName: "Alertstyles__AlertLayoutIcon",
  componentId: "sc-1rvnx1u-2"
})(["flex-shrink:1;align-self:flex-start;margin-right:12px;margin-top:12px;line-height:20px;"]);
var AlertLayoutText = styled.div.withConfig({
  displayName: "Alertstyles__AlertLayoutText",
  componentId: "sc-1rvnx1u-3"
})(["flex-grow:1;flex-wrap:wrap;display:inline-flex;margin-top:14px;margin-bottom:14px;line-height:20px;"]);
var AlertLayoutAction = styled.div.withConfig({
  displayName: "Alertstyles__AlertLayoutAction",
  componentId: "sc-1rvnx1u-4"
})(["flex-shrink:1;padding-left:32px;"]);
var AlertIcon = styled(Icon).withConfig({
  displayName: "Alertstyles__AlertIcon",
  componentId: "sc-1rvnx1u-5"
})(["position:relative;"]);
var AlertTitle = styled.p.withConfig({
  displayName: "Alertstyles__AlertTitle",
  componentId: "sc-1rvnx1u-6"
})(["&:empty{display:none;}font-weight:var(--dentsu-font-weight-bold);font-size:var(--dentsu-font-size-14);margin-right:12px;"]);
var AlertSubtitle = styled.div.withConfig({
  displayName: "Alertstyles__AlertSubtitle",
  componentId: "sc-1rvnx1u-7"
})(["&:empty{display:none;}font-size:var(--dentsu-font-size-14);.", "-link{color:inherit;.", "-link__label{text-decoration:underline;text-underline-position:under;}}"], prefix, prefix);
var AlertLink = styled(Link).attrs({
  isMonochrome: true
}).withConfig({
  displayName: "Alertstyles__AlertLink",
  componentId: "sc-1rvnx1u-8"
})([""]);
var AlertButtonContainer = styled.div.withConfig({
  displayName: "Alertstyles__AlertButtonContainer",
  componentId: "sc-1rvnx1u-9"
})([""]);
var AlertButtonSmall = styled(Button).withConfig({
  displayName: "Alertstyles__AlertButtonSmall",
  componentId: "sc-1rvnx1u-10"
})([""]);
var AlertButtonLarge = styled(Button).withConfig({
  displayName: "Alertstyles__AlertButtonLarge",
  componentId: "sc-1rvnx1u-11"
})([""]);
var AlertCloseButton = styled(CloseButton).withConfig({
  displayName: "Alertstyles__AlertCloseButton",
  componentId: "sc-1rvnx1u-12"
})(["position:absolute;right:16px;top:50%;transform:translateY(-50%);color:var(--dentsu-color-black);.dentsu-icon-button__icon,.dentsu-icon,svg{width:16px;height:16px;}&:hover{box-shadow:none;}"]);
export var Styled = {
  Alert: Alert,
  AlertLayout: AlertLayout,
  AlertLayoutIcon: AlertLayoutIcon,
  AlertLayoutText: AlertLayoutText,
  AlertLayoutAction: AlertLayoutAction,
  AlertIcon: AlertIcon,
  AlertTitle: AlertTitle,
  AlertSubtitle: AlertSubtitle,
  AlertButtonContainer: AlertButtonContainer,
  AlertButtonSmall: AlertButtonSmall,
  AlertButtonLarge: AlertButtonLarge,
  AlertLink: AlertLink,
  AlertCloseButton: AlertCloseButton
};